import React from "react";
import { Star } from "lucide-react";

export const FourStars = ({ size = 14, className = "", color = "#D4AF37" }) => (
  <span data-testid="four-stars-motif" className={`inline-flex items-center gap-1.5 ${className}`} aria-label="Quatre étoiles">
    {[0, 1, 2, 3].map((i) => (
      <Star key={i} size={size} fill={color} stroke={color} strokeWidth={1} />
    ))}
  </span>
);

export const StarsDivider = ({ className = "" }) => (
  <div className={`flex items-center justify-center gap-4 my-10 ${className}`} data-testid="stars-divider">
    <span className="h-px w-16 md:w-32 bg-gradient-to-r from-transparent to-[#D4AF37]/60" />
    <FourStars size={16} />
    <span className="h-px w-16 md:w-32 bg-gradient-to-l from-transparent to-[#D4AF37]/60" />
  </div>
);

export default FourStars;
